import { Component, Mixins } from "vue-property-decorator";
import { CreateElement, VNode } from "vue/types/umd";
import { SchemeType, Contract } from "@foxone/api/src/models/defi";
import mixins from "@/mixins";
import TermContractDetail from "defi/components/contracts/detail/TermDetail.vue";
import { VContainer } from "vuetify/lib";

@Component
class ContractDetailPage extends Mixins(mixins.page) {
  loading = false;

  contract: Contract | null = null;

  get title() {
    return this.$t("defi.invest-detail") as string;
  }

  get id() {
    return this.$route.params.id as string;
  }

  get type() {
    return this.$route.params.type as SchemeType;
  }

  mounted() {
    this.requestContractDetail();
  }

  async requestContractDetail() {
    this.loading = true;
    const actions = this.$api.defi.getActionsBySchemeType(this.type);
    try {
      this.contract = await actions.getContractDetail(this.id);
      this.setProperties();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  render(h: CreateElement): VNode | null {
    if (this.type !== SchemeType.TERM) {
      return null;
    }

    if (this.loading) {
      return h("f-loading", {
        props: { loading: this.loading, fullscreen: true }
      });
    }

    return h(VContainer, [
      h(TermContractDetail, {
        props: { contract: this.contract },
        on: {
          refresh: () => {
            this.requestContractDetail();
          }
        }
      })
    ]);
  }
}

export default ContractDetailPage;
